export default "__VITE_ASSET__Oo0A5ieO__"